import React, { useState } from "react";
import { useDispatch } from "react-redux";
import ActionResultPanel from "../component/common/ActionResultPanel";
import "./Login.css";
import axios from "axios";
import Configuration from "../environment";
import { Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { showMessage } from "../services/MessageService";
import { getCurrentUser } from "../services/AuthenticationService";

import {
  enableLoaderAction,
  disableLoaderAction,
} from "../actions/globat-actions";

const Login = (props) => {
  const [username, setUsername] = useState("");
  const [usernameError, setUsernameError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [redirect, setRedirect] = useState();
  const [actionResult, setActionResult] = useState("");

  const dispatch = useDispatch();

  const handleChangePassword = (event) => {
    setPassword(event.target.value);
  };

  const handleChangeUsername = (event) => {
    setUsername(event.target.value);
  };

  const performLogin = (event) => {
    event.preventDefault();
    setUsernameError("");
    setPasswordError("");
    let validationRuleFailed = false;
    if (username === "") {
      setUsernameError("Ne doit pas être vide");
      validationRuleFailed = true;
    }
    if (password === "") {
      setPasswordError("Ne doit pas être vide");
      validationRuleFailed = true;
    }

    if (validationRuleFailed) {
      return;
    }
    props.performLoading();
    axios
      .post(
        encodeURI(
          Configuration.backend_api_url +
            `/login?username=${username}&password=${password}`
        )
      )
      .then(
        (resp) => {
          setActionResult("success");
          //remove old items
          localStorage.removeItem("token")
          localStorage.removeItem("user")
          localStorage.removeItem("userPic")

          // store JWTs token in localStorage
          localStorage.setItem("token", resp.headers.authorization);
          localStorage.setItem("user", getCurrentUser().sub);
          props.endLoading();
          axios.get(Configuration.backend_api_url + "/users?page=0&pageSize=1&username=" + localStorage.getItem("user"), {
            headers: {
              authorization: localStorage.getItem("token")
            }
          })
          .then(resp=> localStorage.setItem("userPic", resp.data.content[0].pic))
          .finally(()=>{
            setTimeout(() => {
              setRedirect("/home");
            }, 2000);
          })
        },
        (err) => {
          showMessage(dispatch, err.message);
          setActionResult("failed");

        }
      ).finally(()=>{props.endLoading()});
  };

  const [ssoToPerform,setSsoToPerform] = useState(false)

  const performSSO = ()=>{
    if(window.userManager === undefined){
      showMessage(dispatch,"cannot perform SSO , IDP is not reachable")
    }else{
      setSsoToPerform(true)
      window.userManager.signinRedirect()
    }
  }


  if (redirect) {
    return <Redirect to="/home" />;
  }

  return (
    <div className="login">
      <div className="login-brand-panel">
        <div className="login-brand-circle login-brand-circle-1"></div>
        <div className="login-brand-circle login-brand-circle-2"></div>
        <div className="login-brand-circle login-brand-circle-3"></div>

        <div className="login-brand-logo">
          <img alt="" src="SRCS.png" />
          <span>SRCS</span>
        </div>

        <div className="login-brand-pitch">
          <h1>Pilotez votre réseau de diffusion, simplement.</h1>
          <p>
            Contrôleurs, points de vente, contenus publicitaires : une seule
            plateforme pour tout superviser en temps réel.
          </p>
        </div>
      </div>

      <div className="login-form-panel">
        <div className="login-form-card">
          <ActionResultPanel actionResult={actionResult} />

          <h2>Bon retour</h2>
          <p className="login-form-subtitle">
            Connectez-vous à votre espace SRCS
          </p>

          <form onSubmit={performLogin}>
            <div className="login-field">
              <label htmlFor="login-username">Nom d'utilisateur</label>
              <div className={`login-input ${usernameError ? "login-input-error" : ""}`}>
                <i className="fa fa-user" aria-hidden="true"></i>
                <input
                  id="login-username"
                  type="text"
                  name="username"
                  autoComplete="username"
                  value={username}
                  onChange={handleChangeUsername}
                />
              </div>
              {usernameError && <span className="login-field-error">{usernameError}</span>}
            </div>

            <div className="login-field">
              <div className="login-field-header">
                <label htmlFor="login-password">Mot de passe</label>
                <a href="#reset" onClick={(e) => e.preventDefault()}>Mot de passe oublié ?</a>
              </div>
              <div className={`login-input ${passwordError ? "login-input-error" : ""}`}>
                <i className="fa fa-lock" aria-hidden="true"></i>
                <input
                  id="login-password"
                  type={showPassword ? "text" : "password"}
                  name="password"
                  autoComplete="current-password"
                  value={password}
                  onChange={handleChangePassword}
                />
                <button
                  type="button"
                  className="login-input-icon-btn"
                  aria-label={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                  onClick={() => setShowPassword((v) => !v)}
                >
                  <i className={showPassword ? "fa fa-eye-slash" : "fa fa-eye"} aria-hidden="true"></i>
                </button>
              </div>
              {passwordError && <span className="login-field-error">{passwordError}</span>}
            </div>

            <button id="login-button" data-testid="login" type="submit" className="login-submit-btn">
              Se connecter
            </button>

            <div className="login-divider"><span>ou</span></div>

            <button type="button" className="login-sso-btn" onClick={performSSO}>
              Connexion avec SSO
            </button>
          </form>

          <p className="login-help">
            Besoin d'aide ? <a href="#support" onClick={(e) => e.preventDefault()}>Contactez le support</a>
          </p>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  performLoading: () => dispatch(enableLoaderAction()),
  endLoading: () => dispatch(disableLoaderAction()),
});

export default withRouter(connect(null, mapDispatchToProps)(Login));
